import { useQuery } from '@tanstack/react-query';
import { userService } from '../../services';

export const CREATORS_QUERY_KEY = 'creators';

export function useCreators(enabled = true) {
  console.log('[useCreators] Hook called, enabled:', enabled);
  
  const query = useQuery({
    queryKey: [CREATORS_QUERY_KEY],
    queryFn: () => {
      console.log('[useCreators] Query function executing...');
      return userService.getCreators();
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
  
  console.log('[useCreators] Query state:', {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    isSuccess: query.isSuccess,
    data: query.data,
    dataLength: query.data?.length,
    error: query.error
  });
  
  return query;
}
